import { Component, OnDestroy, OnInit, OnChanges, EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import {Location} from '@angular/common';
import { UserFull } from '../../../shared/models/userFull.model';

import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
 import {Observable, Subject} from 'rxjs';


// Notifications

import { DatePipe } from '@angular/common';
import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';
import {UserAvitarModalUploadComponent} from './../../../admin/users/user-avitar-modal-upload/user-avitar-modal-upload.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';
import { ColorPickerComponent, OpenEventArgs } from '@syncfusion/ej2-angular-inputs';
import { SystemAutomation } from 'src/app/shared/models/systemAutomation.model';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { SystemLogType } from 'src/app/shared/models/systemLogType.model';
import { SystemLogTypeDataSectorCondition } from 'src/app/shared/models/systemLogTypeDataSectorCondition.model';
import { SystemLogTypeDataSector } from 'src/app/shared/models/systemLogTypeDataSector.model';
import { SubjectServiceOutcomeTemplate } from 'src/app/shared/models/subjectServiceOutcomeTemplate.model';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, EditorManager, QuickToolbarSettingsModel, InsertHtml } from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection
} from '@syncfusion/ej2-angular-richtexteditor';
import { WooPromotionVariableModalComponent } from '../../system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';


@Component({
  selector: 'app-subject-urgent-outcome-template-update',
  templateUrl: './subject-urgent-outcome-template-update.component.html',
  styleUrls: ['./subject-urgent-outcome-template-update.component.scss']
})
export class SubjectUrgentOutcomeTemplateUpdateComponent implements OnInit {



 // setup as observable?
 @Input() item_id?; // impliments on changes.
 @Input() item_data?; // if data.model is sent ;
 @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
 @Input() item_user_level_id? = '5'; // default to agent just in case
 @Input() item_brand_type_id? = '';
 @Input() show_buttons? = 'no'; // yes | no
 @Input() widget_title? = '';
 @Input() widget_size? = 'full'; // side | abstract | full | update_password


 @ViewChild('defaultRTE', {static: false}) defaultRTE;
 @ViewChild('defaultRTE_b', {static: false}) defaultRTE_b;

 @ViewChild('noteTemplateEditor', {static: false}) noteTemplateEditor;
 @ViewChild('emailTemplateEditor', {static: false}) emailTemplateEditor;
 @ViewChild('noteTemplateEditorPrivate', {static: false}) noteTemplateEditorPrivate;
 @ViewChild('emailTemplateEditorPrivate', {static: false}) emailTemplateEditorPrivate;


 allRecipients = [];
//  allAutomtaions = [];
allAutomations = [];

  // user_id: number;
  brand_user_update: any;
  user_levels: any;
  brands: any;

  @ViewChild('UserForm') form: any;
  updateBrandUserClick;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  brand_types: any;
  brand: any;
  @Input() user_id: number;
  stripped: any;
  filenameselected: any;
  baseUploadURL: string;
  log_type_id: any;
  system_log_type: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
 //Slider
  slidervalue: string;
  ticks: { placement: string; largeStep: number; smallStep: number; showSmallTicks: boolean; };
  changes_made: any = 1;

  isShow_condition_array = false;
  isShow_condition_array_example = false;
  isShow_condition_array_keys_example = false;
  isShow_condition_array_fields = false;
  isShow_database = false;
  isShow_database_model_angular = false;
  isShow_database_mysql = false;
// colour picker
    // @ViewChild('flatbtn')
    // public flatbtn: ButtonComponent;
    // @ViewChild("colorpicker")
    // public colorpicker: ColorPickerComponent;
    // /** Default color value is set */
    // public colorValue: string = '#0db1e7';

    // public Open(args: OpenEventArgs): void {
    //   let applyBtn = (args.element.parentElement).querySelector('.e-ctrl-btn') as HTMLElement;
    //   applyBtn.appendChild(this.flatbtn.element);
    //   this.flatbtn.element.style.display = "inline";
    // }

    // /** Reset button click function is called */
    // public resetBtnClick(): void {
    //   this.colorpicker.value = this.colorValue;
    //    /** Closing color picker popup */
    //   this.colorpicker.toggle();
    //   }
// end picker
public cValue: string = "#1de4d7";
  system_log_type_data_sectors: any;
@Input('UserForm') UserForm: any;
  system_log_levels: any;
  model: SubjectServiceOutcomeTemplate;
  // model: SystemLogTypeDataSector;

  system_log_type_automations: any;
  log_type_data_sector_condition_id: number;
  system_log_type_data_sector_condition: any;
  system_log_type_data_sector: any;
  log_type_data_sector_id: number;
  keys_of_condition_array: string[];
  system_log_type_data_sector_types: any;
  ssot_id: number;
  subject_urgent_outcome_template: any;
  suot_id: number;
  subject_template_doc: any;
  brand_id: string;
@Input('value')
    set value(value: any) {
        this.cValue = value;
    }

 // Text editor Settings
 public simpleToolBar: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  // {
  //   tooltipText: 'Insert Promotion',
  //   undo: true,
  //   click: this.onClickPromotionButton.bind(this),
  //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
  // }
],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public pasteCleanupSettings: object = {
    prompt: true,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
}; 


public simpleToolBar_emailTemplateEditor: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  {
    tooltipText: 'Insert Promotion',
    undo: true,
    click: this.onClickPromotionButton_emailTemplate.bind(this),
    template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
  },

  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'

],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  }; 
  
  public simpleToolBar_noteTemplateEditor: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Promotion',
      undo: true,
      click: this.onClickPromotionButton_noteTemplate.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };   

  public simpleToolBar_noteTemplateEditorPrivate: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Promotion',
      undo: true,
      click: this.onClickPromotionButton_noteTemplatePrivate.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };       

    public simpleToolBar_emailTemplateEditorPrivate: object = {
      type: 'Expand',
      enableFloating: false,
      items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|',
      {
        tooltipText: 'Insert Promotion',
        undo: true,
        click: this.onClickPromotionButton_emailTemplatePrivate.bind(this),
        template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
      },
  
      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|',
      'CreateLink', '|', 'ClearFormat', 'Print',
      'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  
    ],
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
      };    
 




  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router:Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _location: Location,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    private sanitizer: DomSanitizer,
  ) { 


      // login vars
  this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
  console.log('sessionUserId: ', this.currentUserVAR.user_id );
  console.log('sessionUsername: ', this.currentUserVAR.username );
  // Set loggind in User Value (USER ID)
  this.sessionUserId = this.currentUserVAR.user_id;
  this.sessionUserName = this.currentUserVAR.username;
  this.sessionBrandId = this.currentUserVAR.brand_id;

  this.log_type_id = +this.route.snapshot.paramMap.get('log_type_id');
  this.log_type_data_sector_condition_id = +this.route.snapshot.paramMap.get('log_type_data_sector_condition_id');
  this.log_type_data_sector_id = +this.route.snapshot.paramMap.get('log_type_data_sector_id');
  this.ssot_id = +this.route.snapshot.paramMap.get('ssot_id');
  this.suot_id = +this.route.snapshot.paramMap.get('suot_id');

  this.slidervalue = "30";
this.ticks = {
    placement: 'Before',
    largeStep: 20,
    smallStep: 5,
    showSmallTicks: true
  };

   }




 // check for changes. to load data.
 ngOnChanges(changes) {
  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.ssot_id = changes.item_id.currentValue;
   //  this.getBrandById(this.brand_id);
  //  this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing slash


  this.model = new SubjectServiceOutcomeTemplate();
  // this.getSystemLogTypeDataSectorCondition(this.log_type_data_sector_condition_id)
 
  // this.getSubjectServiceOutcomeTemplate(this.ssot_id)

  this.getSystemLogTypeDataSectorTypes();
  // this.getSystemLogTypeDataSectors();
  // this.getSystemLogLevels();
    // this.getBrandUser(this.gfunc.sessionUserId);
    // this.getFormUserLevels();
    // this.getBrands();
  }
}



  ngOnInit() {
    this.model = new SystemLogTypeDataSector();

 // Set the model.?
//  this.getSystemLogType(this.log_type_id)
// this.getSystemLogTypeDataSectorCondition(this.log_type_data_sector_condition_id);

// this.getSubjectServiceOutcomeTemplate(this.ssot_id)
this.getSubjectUrgentOutcomeTemplate(this.suot_id)
this.getSystemLogTypeDataSectorTypes();
 
// this.getSystemLogTypeDataSectors();
//  this.getSystemLogLevels();
  }


setColour(value2){
  console.log('SetColour: ' + value2)
  this.UserForm.log_type_colour.value = this.UserForm.colourpicker.value
}




addValue(){
  this.model.ssot_template_WORD = " Some special Text Appended";
}



   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Image / Photo',
      item_id: 1010,
      user_id: this.user_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UserAvitarModalUploadComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.user_id = this.user_id;
   // this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.user_id;
    this.bsModalRef.content.closeBtnName = 'Close';
    // subscribed to the emitter and get the value.
          //   this.bsModalRef.content.action.take(1).subscribe((value) => {
          // // console.log(value); // here you will get the value of the file
          // // Remove the "uploads/" part from the filename.
          // this.filenameselected = value;
          // this.stripped = this.filenameselected.replace('uploads/', '');
          // // this.model.main_image = this.stripped; // works for simple add not update.
          // // console.log(this.stripped);
          // // console.log(this.model);
          // this.form.photo = this.stripped;
          // // this.form.reset();
          // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
          // this.form.controls['photo'].patchValue(this.form.photo);
          // });


  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_P.bind(this)); /// THIS WORKLED // when clicked.....

   }

// :: Parent / Child modal test
public addFileNameFromModal_P(filename) {

  // this.model.logo = filename;
  this.form.controls['photo'].patchValue(filename); // works by setting the new frorm value from parent modal.

// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};

 
// Database Functions
getBrandUser(user_id) {
  this._demoService.getBrandUser(user_id).subscribe(
     data => { this.brand_user_update = data;
    
    },
     err => console.error(err),
     () => console.log('done loading user for update')
   );
 }



 getSystemLogType(log_type_id) {
  this._demoService.getSystemLogType(log_type_id).subscribe(
     data => { this.system_log_type = data;

      let res = data[0]
      // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
      // this.allAutomations = JSON.parse(this.system_log_type[0].system_automation_array);
      // Lookup the Automations

      // let new_model = {
      //   system_automation_array: JSON.parse(this.system_log_type[0].system_automation_array)
      // }
      // this.getSystemAutomationsArray(new_model);

    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


 private getSubjectServiceOutcomeTemplate(ssot_id) {
  this._demoService.getSubjectServiceOutcomeTemplate(ssot_id)
    .subscribe(
      res => {
        this.system_log_type_data_sector = res;
        let data = res[0]


            // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
            // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
            // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

            // let new_model = {
            //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
            // }
            // this.getSystemSubjectTemplateDocsArray(new_model);

            // let new_model_b = {
            //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
            // }
            // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

            
            // let new_model_c = {
            //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
            // }
            // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);



        // this.getSystemLogType(data.system_log_type_id);
      },
      err => console.error(err.status)
    );
}


 getSubjectUrgentOutcomeTemplate(suot_id) {
  this._demoService.getSubjectUrgentOutcomeTemplate(suot_id)
    .subscribe(
      res => {
        this.subject_urgent_outcome_template = res;
        let data = res[0]


            // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
            // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
            // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

            // let new_model = {
            //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
            // }
            // this.getSystemSubjectTemplateDocsArray(new_model);

            // let new_model_b = {
            //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
            // }
            // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

            
            // let new_model_c = {
            //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
            // }
            // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);



        // this.getSystemLogType(data.system_log_type_id);
      },
      err => console.error(err.status)
    );
}


 getSystemLogTypeDataSectorCondition(log_type_data_sector_condition_id) {
  this._demoService.getSystemLogTypeDataSectorCondition(log_type_data_sector_condition_id).subscribe(
     data => { this.system_log_type_data_sector_condition = data;

      let res = data[0]
      // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
      // this.allAutomations = JSON.parse(this.system_log_type[0].system_automation_array);
      // Lookup the Automations

      // let new_model = {
      //   system_automation_array: JSON.parse(this.system_log_type[0].system_automation_array)
      // }
      // this.getSystemAutomationsArray(new_model);

    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


 getSystemLogTypeDataSector(log_type_data_sector_id) {
  this._demoService.getSystemLogTypeDataSector(log_type_data_sector_id).subscribe(
     data => { this.system_log_type_data_sector = data;

      let res = data[0]
      // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
      // this.allAutomations = JSON.parse(this.system_log_type[0].system_automation_array);
      // Lookup the Automations

      // let new_model = {
      //   system_automation_array: JSON.parse(this.system_log_type[0].system_automation_array)
      // }
      // this.getSystemAutomationsArray(new_model);

      this.keys_of_condition_array = Object.keys( JSON.parse(res.condition_array))
      

    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


 getSystemLogTypeDataSectors() {
  this._demoService.getSystemLogTypeDataSectors().subscribe(
     data => { this.system_log_type_data_sectors = data;
    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


 getSystemLogTypeDataSectorTypes() {
  this._demoService.getSystemLogTypeDataSectorTypes().subscribe(
     data => { this.system_log_type_data_sector_types = data;
    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }




  // MODAL
  // start of modal windows service as a template
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



 getSystemLogLevels() {
  this._demoService.getSystemLogLevels().subscribe(
     data => { this.system_log_levels = data;
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


// update was here for onit but moved for onchange
updateBrandUser(model) {
this._demoService.updateBrandUser(model).subscribe(
   data => {
    console.log(model);
     // this.trace_candidate_update = data;
   this.toastr.success('User Updated');
   this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
   this.gfunc.globalUserView(model.user_id);
   // Subject to reload the manager component parent.
  // BrandUserManagerComponent.returned.next(false);
     return true;
   },
   error => {
     console.error('Error saving User!');
    return console.log(error);
   }
  // err => console.error(err),
  // () => console.log('done updates')
);
}

// update was here for onit but moved for onchange
updateSystemLogType(model) {

  // model.system_automation_array = this.allAutomtaions;

        this._demoService.updateSystemLogType(model).subscribe(
           data => {
            console.log(model);
             // this.trace_candidate_update = data;
           this.toastr.success('Log Type Updated');
          //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
          //  this.gfunc.globalUserView(model.user_id);
           // Subject to reload the manager component parent.
          // BrandUserManagerComponent.returned.next(false);
             return true;
           },
           error => {
             console.error('Error saving Log Type!');
            return console.log(error);
           }
          // err => console.error(err),
          // () => console.log('done updates')
        );
  }
  


  
// update was here for onit but moved for onchange
updateSystemLogTypeDataSectorCondition(model) {

  // model.system_automation_array = this.allAutomtaions;

        this._demoService.updateSystemLogTypeDataSectorCondition(model).subscribe(
           data => {
            console.log(model);
             // this.trace_candidate_update = data;
           this.toastr.success('Log Type Data Sector Condition Updated');
          //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
          //  this.gfunc.globalUserView(model.user_id);
           // Subject to reload the manager component parent.
          // BrandUserManagerComponent.returned.next(false);
             return true;
           },
           error => {
             console.error('Error saving Log Type Data Sector Condition!');
            return console.log(error);
           }
          // err => console.error(err),
          // () => console.log('done updates')
        );
  }




  updateSubjectServiceOutcomeTemplate(model) {

    // model.system_automation_array = this.allAutomtaions;
  
          this._demoService.updateSubjectServiceOutcomeTemplate(model).subscribe(
             data => {
              console.log(model);
               // this.trace_candidate_update = data;
             this.toastr.success('Subject Service Outcome Template Updated');
            //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
            //  this.gfunc.globalUserView(model.user_id);
             // Subject to reload the manager component parent.
            // BrandUserManagerComponent.returned.next(false);
               return true;
             },
             error => {
               console.error('Error saving Subject Service Outcome Template!');
              return console.log(error);
             }
            // err => console.error(err),
            // () => console.log('done updates')
          );
    }

    updateSubjectUrgentOutcomeTemplate(model) {

      // model.system_automation_array = this.allAutomtaions;
    
            this._demoService.updateSubjectUrgentOutcomeTemplate(model).subscribe(
               data => {
                console.log(model);
                 // this.trace_candidate_update = data;
               this.toastr.success('Subject Urgent Outcome Template Updated');
              //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
              //  this.gfunc.globalUserView(model.user_id);
               // Subject to reload the manager component parent.
              // BrandUserManagerComponent.returned.next(false);
                 return true;
               },
               error => {
                 console.error('Error saving Subject Urgent Outcome Template!');
                return console.log(error);
               }
              // err => console.error(err),
              // () => console.log('done updates')
            );
      }

      
  updateSystemLogTypeDataSector(model) {

    // model.system_automation_array = this.allAutomtaions;
  
          this._demoService.updateSystemLogTypeDataSector(model).subscribe(
             data => {
              console.log(model);
               // this.trace_candidate_update = data;
             this.toastr.success('Log Type Data Sector Updated');
            //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
            //  this.gfunc.globalUserView(model.user_id);
             // Subject to reload the manager component parent.
            // BrandUserManagerComponent.returned.next(false);
               return true;
             },
             error => {
               console.error('Error saving Log Type Data Sector!');
              return console.log(error);
             }
            // err => console.error(err),
            // () => console.log('done updates')
          );
    }

getFormUserLevels() {
  this._demoService.getFormUserLevels().subscribe(
     data2 => { this.user_levels = data2;
      console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }


 getBrands() {
  this._demoService.getBrands().subscribe(
     data2 => { this.brands = data2;
     // console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Brands')
   );
 }



 addRecipientFromModal(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allRecipients.push(
  system_automation_id
);

this.allRecipients = this.allRecipients;
// this.model.allRecipients = this.allRecipients;

// this.model.system_automation_array = this.allRecipients;

// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )


this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};




addAutomationFromModal(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allAutomations.push(
  system_automation_id
);

this.allAutomations = this.allAutomations;
// this.model.system_automation_array = this.allAutomtaions;

// simple small updated - quick and then refresh the page
// this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// this.model.log_type_id = this.log_type_id;

this.form.controls['system_automation_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
// rest the list
let new_model = {
  system_automation_array: this.allAutomations
}
this.getSystemAutomationsArray(new_model);


// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )
// this.model.system_automation_array = this.allAutomtaions;
// this.updateSystemLogType(model);
// this.getSystemLogType(this.log_type_id);

this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};

// :: Parent / Child modal test
closeParentModelDefault(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};



RemoveElementFromAllRecipients(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allRecipients.forEach((value, index) => {
    if (value === key) {
      this.allRecipients.splice(index, 1);
    }
  });

    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


RemoveElementFromAllAutomations(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAutomations.forEach((value, index) => {
    if (value === key) {
      this.allAutomations.splice(index, 1);
    }
  });

      this.form.controls['system_automation_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_automation_array: this.allAutomations
      }
      this.getSystemAutomationsArray(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};

getSystemAutomationsArray(request_array) {
  this._demoService.getSystemAutomationsArray(request_array).subscribe(
     data => { this.system_log_type_automations = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
}

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }


  onChangePromtSave(any) {
    //  alert('you have made changes, please remember to save!');
    //  console.log('form changed');
     this.changes_made = null;
    }
  
    onChangePromtSaveHide() {
      //  alert('you have made changes, please remember to save!');
      //  console.log('form changed');
       this.changes_made = 1;
      }




      // Variable Modal Functions

public onClickPromotionButton_noteTemplate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_noteTemplate();
}

public onClickPromotionButton_noteTemplatePrivate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_noteTemplatePrivate();
}

public onClickPromotionButton_emailTemplate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_emailTemplate();
}  

public onClickPromotionButton_emailTemplatePrivate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_emailTemplatePrivate();
}  

public onClickPromotionButton_emailSubjectTemplate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_emailSubjectTemplate();
}  
      

  // MODAL view a component
    // MODAL view a component
    openModalWithComponent_Promotion_noteTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "noteTemplate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'noteTemplate',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }
  
    openModalWithComponent_Promotion_noteTemplatePrivate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "noteTemplatePrivate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      
      this.bsModalRef.content.editorID = 'noteTemplatePrivate',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
               
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }  
  
    openModalWithComponent_Promotion_emailTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "emailTemplate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'emailTemplate',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
  
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }  
  
    openModalWithComponent_Promotion_emailTemplatePrivate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "emailTemplatePrivate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'emailTemplatePrivate',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
  
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }  
  
  // testing for normal form file button.
    openModalWithComponent_Promotion_emailSubjectTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "emailSubjectTemplate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'emailSubjectTemplate',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }  
    openModalWithComponent_Promotion_emailSubjectTemplatePrivate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "emailSubjectTemplatePrivate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'emailSubjectTemplatePrivate',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
  
  
       // this willl have to be avariable.
            // :: Parent / Child modal test
            public insertPromotionFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                      // auto inserts the variable name of theat which was sent.
                      let insert_tag = 'NOT USED -- {{' + fileurl + '}}'
        
              // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
        
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
      
      
            public insertStrFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                      // auto inserts the variable name of theat which was sent.
                      let insert_tag = '' + fileurl + ''
        
              // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
        
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
      
      
            public insertVariableFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                      // auto inserts the variable name of theat which was sent.
                    //  pps
                      // let insert_tag = '${' + fileurl + '}'
    
                      // sharmans
                      let insert_tag = fileurl;
    
    
              // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
              // Need an if statment and to get the Editor ID , to have muliple occurannces on one page.
  
    
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
    
    
    
    
            public insertImageQRFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
        
                      // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
    
                                      // april 28 2023 - now in assets of brand.
                    let link = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id + '/qrcodes/' + fileurl;
                    let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="'+ link + '" >'
      
                      // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src=" https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
        
              // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
        
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
  
  
  
  
    // :: Parent / Child modal test
    public insertImageFromModal(fileurl) {
      // alert('Clicked Insert');
  
  
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
              let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'
  
      // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
      this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
      // InsertHtml.Insert(document, document.createTextNode(fileurl));
      InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
      // InsertHtml.Insert(document, document.createElement('image') )
  
  
      // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
  
  
      // insertImage(fileurl);
  
      // has to be correct form name
    // this.modalRef.hide();
    // console.log('Added External Recipeint.');
    // this.toastr.info('External Recipient Added');
    };
  
  
  
    // Now workes for multiple editors on a page... few!! 11pm 2/12/23
    public insertVariableFromModal_EditorID(fileurl) {
      // alert('Clicked Insert');
  
      console.log(JSON.stringify(fileurl))
      let editorID = fileurl.editorID
      let insert_variable = fileurl.fileurl
  
      this.toastr.info('Variable Inserted: ' + insert_variable)
  
      // this.toastr.info('editorID: ' + editorID)
  
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
              // auto inserts the variable name of theat which was sent.
            //  pps
              // let insert_tag = '${' + fileurl + '}'
  
              // sharmans
      // let insert_tag = fileurl;
      // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
      // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
  
          // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // // InsertHtml.Insert(document, document.createTextNode(fileurl));
          // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // // InsertHtml.Insert(document, document.createElement('image') )
  
          // // Need an if statment and to get the Editor ID , to have muliple occurannces on one page.
  
        
      if (editorID == 'emailSubjectTemplate'){  
        // Now adds to the subject
        let currentValue =   this.form.controls['email_subject_primary'].value;
        let newValue = '';
        if(currentValue == null){
          newValue = insert_variable;
        }else{
          newValue = currentValue + ' ' + insert_variable;
        }
        this.form.controls['email_subject_primary'].patchValue(newValue);
      }
  
      if (editorID == 'emailSubjectTemplatePrivate'){  
        // Now adds to the subject
        let currentValue =   this.form.controls['email_subject_private'].value;
        let newValue = '';
        if(currentValue == null){
          newValue = insert_variable;
        }else{
          newValue = currentValue + ' ' + insert_variable;
        }
        this.form.controls['email_subject_private'].patchValue(newValue);
      }
  
          
    if (editorID == 'emailTemplate'){
      this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
      } 
      
      if (editorID == 'emailTemplatePrivate'){
        this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
        InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
        }    
  
          // NoteTemplate Editor.
     if (editorID == 'noteTemplate'){
      this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
     }
  
          // NoteTemplate Editor.
          if (editorID == 'noteTemplatePrivate'){
            this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
            InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
           }
        
  
     if (editorID == 'defaultRTE'){
      this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
     }
      // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
  
  
      // insertImage(fileurl);
  
      // has to be correct form name
    // this.modalRef.hide();
    // console.log('Added External Recipeint.');
    // this.toastr.info('External Recipient Added');
    };
  
  // Now works to insert uploaded images directly from the tabs for -- blocked for Email Subject
    public insertImageFromModal_EditorID(fileurl) {
     
      // Need to create the new button in HTML widget to click.
      console.log(JSON.stringify(fileurl))
      let editorID = fileurl.editorID
      let insert_variable = fileurl.fileurl
     
      // alert('Clicked Insert');
  
  
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
              // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'
              let insert_tag = '<img class="e-rte-image e-imginline e-img-focus"  src="' + insert_variable + '" >'
  
  
              if (editorID == 'defaultRTE'){
                            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
               }
            
              //  if (editorID == 'emailSignatureTemplate'){
              //   this.emailSignatureTemplate.focusIn(); // these two lines work for RichTextEditor
              //   InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              //  }
  
  
               // Ugraded for communications to accept images
  
                if (editorID == 'emailTemplate'){
                  this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
                } 
  
                if (editorID == 'emailTemplatePrivate'){
                  this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
                }    
  
                // NoteTemplate Editor.
                if (editorID == 'noteTemplate'){
                  this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
                }
  
                // NoteTemplate Editor.
                if (editorID == 'noteTemplatePrivate'){
                  this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                }
  
  
  
  
  
  
                    // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
                    // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
                    // // InsertHtml.Insert(document, document.createTextNode(fileurl));
                    // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                    // // InsertHtml.Insert(document, document.createElement('image') )
  
  
  
      
  
      // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
  
  
      // insertImage(fileurl);
  
      // has to be correct form name
    // this.modalRef.hide();
    // console.log('Added External Recipeint.');
    // this.toastr.info('External Recipient Added');
    };
  
  
  
      // END OF IMAGE modal 




}